const read = require('./read')
const write = require('./write')

module.exports = Object.assign({}, read, write)
